export const defaultData = {
    "type": "force",
    "categories": [
        {
            "name": "VUS",
            "itemStyle": {
                "color": "#999999"
            }
        },
        {
            "name": "P",
            "itemStyle": {
                "color": "#d32f2f"
            }
        }
    ],
    "nodes": [
        {
            "name": "13_20763095_T_G_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763485_AG_A_P",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763110_AG_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763115_G_GCAAATTCCAGACACTGCAATCATGAACACTGTGAAGACAGTCTTCT_P",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763294_G_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763420_CAT_C_P",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763464_G_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Strong"
        },
        {
            "name": "13_20763529_GCACACGTTCTTGCAGC_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763612_C_T_P",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763685_A_AC_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Strong"
        },
        {
            "name": "13_20763123_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763243_C_T_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763137_A_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763209_G_GCGTT_P",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763150_A_G_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763305_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "NA"
        },
        {
            "name": "13_20763162_C_T_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763164_G_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763265_G_C_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763170_C_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763170_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763171_G_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763193_G_C_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763194_T_C_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763200_C_T_P",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763206_CA_C_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763471_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Strong"
        },
        {
            "name": "13_20763491_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763248_TACATG_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763250_C_T_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763257_T_C_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763271_GAAGGCGGCTTCGAAGATGA_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763275_G_T_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763282_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Strong"
        },
        {
            "name": "13_20763293_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Strong"
        },
        {
            "name": "13_20763685_AC_A_P",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763294_GGAA_G_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763301_G_C_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763471_C_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Strong"
        },
        {
            "name": "13_20763313_G_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763322_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763323_C_G_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763332_C_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763452_A_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763333_C_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763341_C_A_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763342_G_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763344_A_G_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763366_C_T_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763377_A_C_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763394_CCCCTTGATGAACTT_C_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Strong"
        },
        {
            "name": "13_20766921_C_T_P",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763464_G_C_P",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763621_TA_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763626_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Strong"
        },
        {
            "name": "13_20763712_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Strong"
        },
        {
            "name": "13_20763438_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Strong"
        },
        {
            "name": "13_20763489_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763441_G_T_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763582_C_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_VeryStrong"
        },
        {
            "name": "13_20763458_G_C_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763627_G_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763482_T_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763485_A_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763559_GT_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763563_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763594_C_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763612_CG_C_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763626_C_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763627_GA_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763650_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Strong"
        },
        {
            "name": "13_20763652_G_C_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763698_G_A_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763702_G_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763713_C_T_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763718_C_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763719_A_C_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763497_C_T_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763498_G_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763607_CACA_C_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763633_T_C_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763633_T_G_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763649_C_G_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763662_A_G_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Moderate"
        },
        {
            "name": "13_20763668_G_A_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763687_C_A_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763710_C_T_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Strong"
        },
        {
            "name": "13_20763713_C_G_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763743_C_G_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20766903_C_A_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763686_C_A_VUS",
            "value": 1,
            "category": 1,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20763748_A_G_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        },
        {
            "name": "13_20766911_G_A_VUS",
            "value": 1,
            "category": 0,
            "PM3": "PM3_Supporting"
        }
    ],
    "links": [
        {
            "source": 0,
            "target": 1,
            "value": 1
        },
        {
            "source": 1,
            "target": 2,
            "value": 1
        },
        {
            "source": 1,
            "target": 3,
            "value": 8
        },
        {
            "source": 1,
            "target": 10,
            "value": 8
        },
        {
            "source": 1,
            "target": 14,
            "value": 1
        },
        {
            "source": 1,
            "target": 16,
            "value": 1
        },
        {
            "source": 1,
            "target": 19,
            "value": 1
        },
        {
            "source": 1,
            "target": 21,
            "value": 1
        },
        {
            "source": 1,
            "target": 23,
            "value": 1
        },
        {
            "source": 1,
            "target": 13,
            "value": 13
        },
        {
            "source": 1,
            "target": 11,
            "value": 1
        },
        {
            "source": 1,
            "target": 18,
            "value": 2
        },
        {
            "source": 1,
            "target": 31,
            "value": 1
        },
        {
            "source": 1,
            "target": 32,
            "value": 2
        },
        {
            "source": 1,
            "target": 33,
            "value": 4
        },
        {
            "source": 1,
            "target": 4,
            "value": 1
        },
        {
            "source": 1,
            "target": 40,
            "value": 1
        },
        {
            "source": 1,
            "target": 44,
            "value": 1
        },
        {
            "source": 1,
            "target": 45,
            "value": 1
        },
        {
            "source": 1,
            "target": 46,
            "value": 3
        },
        {
            "source": 1,
            "target": 48,
            "value": 1
        },
        {
            "source": 1,
            "target": 50,
            "value": 2
        },
        {
            "source": 1,
            "target": 5,
            "value": 33
        },
        {
            "source": 1,
            "target": 56,
            "value": 1
        },
        {
            "source": 1,
            "target": 6,
            "value": 1
        },
        {
            "source": 1,
            "target": 52,
            "value": 6
        },
        {
            "source": 1,
            "target": 38,
            "value": 1
        },
        {
            "source": 1,
            "target": 62,
            "value": 1
        },
        {
            "source": 1,
            "target": 63,
            "value": 1
        },
        {
            "source": 1,
            "target": 1,
            "value": 126
        },
        {
            "source": 1,
            "target": 27,
            "value": 9
        },
        {
            "source": 1,
            "target": 7,
            "value": 13
        },
        {
            "source": 1,
            "target": 64,
            "value": 1
        },
        {
            "source": 1,
            "target": 65,
            "value": 1
        },
        {
            "source": 1,
            "target": 59,
            "value": 7
        },
        {
            "source": 1,
            "target": 66,
            "value": 1
        },
        {
            "source": 1,
            "target": 8,
            "value": 92
        },
        {
            "source": 1,
            "target": 67,
            "value": 1
        },
        {
            "source": 1,
            "target": 68,
            "value": 2
        },
        {
            "source": 1,
            "target": 54,
            "value": 3
        },
        {
            "source": 1,
            "target": 69,
            "value": 1
        },
        {
            "source": 1,
            "target": 70,
            "value": 3
        },
        {
            "source": 1,
            "target": 71,
            "value": 1
        },
        {
            "source": 1,
            "target": 9,
            "value": 1
        },
        {
            "source": 1,
            "target": 35,
            "value": 7
        },
        {
            "source": 1,
            "target": 72,
            "value": 1
        },
        {
            "source": 1,
            "target": 73,
            "value": 1
        },
        {
            "source": 1,
            "target": 74,
            "value": 2
        },
        {
            "source": 1,
            "target": 75,
            "value": 1
        },
        {
            "source": 1,
            "target": 76,
            "value": 1
        },
        {
            "source": 1,
            "target": 51,
            "value": 4
        },
        {
            "source": 3,
            "target": 3,
            "value": 2
        },
        {
            "source": 3,
            "target": 4,
            "value": 1
        },
        {
            "source": 3,
            "target": 5,
            "value": 5
        },
        {
            "source": 3,
            "target": 6,
            "value": 1
        },
        {
            "source": 3,
            "target": 7,
            "value": 1
        },
        {
            "source": 3,
            "target": 8,
            "value": 2
        },
        {
            "source": 3,
            "target": 9,
            "value": 1
        },
        {
            "source": 4,
            "target": 8,
            "value": 10
        },
        {
            "source": 4,
            "target": 35,
            "value": 2
        },
        {
            "source": 5,
            "target": 10,
            "value": 1
        },
        {
            "source": 5,
            "target": 14,
            "value": 1
        },
        {
            "source": 5,
            "target": 13,
            "value": 3
        },
        {
            "source": 5,
            "target": 34,
            "value": 1
        },
        {
            "source": 5,
            "target": 39,
            "value": 1
        },
        {
            "source": 5,
            "target": 5,
            "value": 12
        },
        {
            "source": 5,
            "target": 52,
            "value": 3
        },
        {
            "source": 5,
            "target": 38,
            "value": 1
        },
        {
            "source": 5,
            "target": 27,
            "value": 2
        },
        {
            "source": 5,
            "target": 7,
            "value": 4
        },
        {
            "source": 5,
            "target": 8,
            "value": 22
        },
        {
            "source": 5,
            "target": 53,
            "value": 1
        },
        {
            "source": 5,
            "target": 54,
            "value": 1
        },
        {
            "source": 5,
            "target": 9,
            "value": 2
        },
        {
            "source": 5,
            "target": 35,
            "value": 2
        },
        {
            "source": 5,
            "target": 55,
            "value": 2
        },
        {
            "source": 6,
            "target": 8,
            "value": 3
        },
        {
            "source": 7,
            "target": 10,
            "value": 1
        },
        {
            "source": 7,
            "target": 28,
            "value": 2
        },
        {
            "source": 7,
            "target": 8,
            "value": 4
        },
        {
            "source": 7,
            "target": 35,
            "value": 1
        },
        {
            "source": 7,
            "target": 55,
            "value": 1
        },
        {
            "source": 7,
            "target": 51,
            "value": 1
        },
        {
            "source": 8,
            "target": 14,
            "value": 19
        },
        {
            "source": 8,
            "target": 17,
            "value": 1
        },
        {
            "source": 8,
            "target": 20,
            "value": 1
        },
        {
            "source": 8,
            "target": 22,
            "value": 1
        },
        {
            "source": 8,
            "target": 25,
            "value": 1
        },
        {
            "source": 8,
            "target": 13,
            "value": 1
        },
        {
            "source": 8,
            "target": 11,
            "value": 1
        },
        {
            "source": 8,
            "target": 29,
            "value": 1
        },
        {
            "source": 8,
            "target": 30,
            "value": 2
        },
        {
            "source": 8,
            "target": 34,
            "value": 3
        },
        {
            "source": 8,
            "target": 36,
            "value": 3
        },
        {
            "source": 8,
            "target": 37,
            "value": 1
        },
        {
            "source": 8,
            "target": 41,
            "value": 1
        },
        {
            "source": 8,
            "target": 42,
            "value": 1
        },
        {
            "source": 8,
            "target": 46,
            "value": 5
        },
        {
            "source": 8,
            "target": 47,
            "value": 1
        },
        {
            "source": 8,
            "target": 49,
            "value": 1
        },
        {
            "source": 8,
            "target": 56,
            "value": 4
        },
        {
            "source": 8,
            "target": 60,
            "value": 1
        },
        {
            "source": 8,
            "target": 38,
            "value": 1
        },
        {
            "source": 8,
            "target": 26,
            "value": 3
        },
        {
            "source": 8,
            "target": 57,
            "value": 1
        },
        {
            "source": 8,
            "target": 77,
            "value": 2
        },
        {
            "source": 8,
            "target": 78,
            "value": 1
        },
        {
            "source": 8,
            "target": 59,
            "value": 1
        },
        {
            "source": 8,
            "target": 79,
            "value": 1
        },
        {
            "source": 8,
            "target": 8,
            "value": 425
        },
        {
            "source": 8,
            "target": 80,
            "value": 1
        },
        {
            "source": 8,
            "target": 81,
            "value": 1
        },
        {
            "source": 8,
            "target": 82,
            "value": 1
        },
        {
            "source": 8,
            "target": 83,
            "value": 3
        },
        {
            "source": 8,
            "target": 84,
            "value": 1
        },
        {
            "source": 8,
            "target": 9,
            "value": 3
        },
        {
            "source": 8,
            "target": 85,
            "value": 1
        },
        {
            "source": 8,
            "target": 86,
            "value": 4
        },
        {
            "source": 8,
            "target": 55,
            "value": 1
        },
        {
            "source": 8,
            "target": 87,
            "value": 1
        },
        {
            "source": 8,
            "target": 88,
            "value": 1
        },
        {
            "source": 8,
            "target": 89,
            "value": 1
        },
        {
            "source": 8,
            "target": 51,
            "value": 2
        },
        {
            "source": 10,
            "target": 11,
            "value": 1
        },
        {
            "source": 12,
            "target": 13,
            "value": 1
        },
        {
            "source": 13,
            "target": 13,
            "value": 2
        },
        {
            "source": 13,
            "target": 26,
            "value": 1
        },
        {
            "source": 13,
            "target": 27,
            "value": 1
        },
        {
            "source": 14,
            "target": 15,
            "value": 1
        },
        {
            "source": 17,
            "target": 18,
            "value": 1
        },
        {
            "source": 24,
            "target": 24,
            "value": 2
        },
        {
            "source": 35,
            "target": 50,
            "value": 1
        },
        {
            "source": 35,
            "target": 70,
            "value": 1
        },
        {
            "source": 35,
            "target": 35,
            "value": 9
        },
        {
            "source": 35,
            "target": 51,
            "value": 5
        },
        {
            "source": 37,
            "target": 38,
            "value": 1
        },
        {
            "source": 42,
            "target": 43,
            "value": 1
        },
        {
            "source": 50,
            "target": 50,
            "value": 1
        },
        {
            "source": 50,
            "target": 51,
            "value": 1
        },
        {
            "source": 51,
            "target": 90,
            "value": 1
        },
        {
            "source": 51,
            "target": 86,
            "value": 1
        },
        {
            "source": 51,
            "target": 51,
            "value": 3
        },
        {
            "source": 52,
            "target": 52,
            "value": 2
        },
        {
            "source": 52,
            "target": 61,
            "value": 1
        },
        {
            "source": 54,
            "target": 54,
            "value": 1
        },
        {
            "source": 56,
            "target": 57,
            "value": 1
        },
        {
            "source": 58,
            "target": 59,
            "value": 1
        },
        {
            "source": 59,
            "target": 59,
            "value": 1
        },
        {
            "source": 86,
            "target": 86,
            "value": 1
        },
        {
            "source": 91,
            "target": 91,
            "value": 1
        },
        {
            "source": 92,
            "target": 92,
            "value": 1
        }
    ]
}